<template>
  <div class="azcon-collection-card-skeleton">
    <div class="azcon-collection-card-skeleton__cover"></div>
    <div class="azcon-collection-card-skeleton__name"></div>
  </div>
</template>

<script>
export default {
  name: "AzconCollectionCardSkeleton",
};
</script>

<style lang="scss" scoped>
.azcon-collection-card-skeleton {
  width: 160px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e8ecf1;
  background: #fff;

  &__cover {
    width: 100%;
    aspect-ratio: 16 / 10;
    background: linear-gradient(90deg, #e8edf3 25%, #dce3eb 50%, #e8edf3 75%);
    background-size: 200% 100%;
    animation: azcon-shimmer 1.5s infinite;
  }

  &__name {
    margin: 6px 8px;
    width: 65%;
    height: 12px;
    border-radius: 4px;
    background: linear-gradient(90deg, #e8edf3 25%, #dce3eb 50%, #e8edf3 75%);
    background-size: 200% 100%;
    animation: azcon-shimmer 1.5s infinite;
  }
}

@keyframes azcon-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
